/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FolderCto } from '../../models/folder-cto';

export interface GetCompanyFolders$Plain$Params {
  companyId: string;
}

export function getCompanyFolders$Plain(http: HttpClient, rootUrl: string, params: GetCompanyFolders$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FolderCto>>> {
  const rb = new RequestBuilder(rootUrl, getCompanyFolders$Plain.PATH, 'get');
  if (params) {
    rb.path('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FolderCto>>;
    })
  );
}

getCompanyFolders$Plain.PATH = '/company/{companyId}/folders';
